var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26648 7.20823C5.66222 7.6354 6.33781 7.63543 6.73358 7.20829L11.3485 2.22774C11.7161 1.83095 11.7163 1.21801 11.349 0.820965V0.820965C10.9393 0.37818 10.2393 0.378048 9.82942 0.820676L6 4.95623L2.17102 0.820252C1.76138 0.377768 1.06176 0.377615 0.651924 0.819922V0.819922C0.284109 1.21688 0.284084 1.83015 0.651865 2.22714L5.26648 7.20823Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.20f061a660330aa873f18932dc55bf69.svg";
export { ForwardRef as ReactComponent };